import { useGrid } from '@/components/Grid';
import { buildEditLink, getInfo, NameAndLabelFormatter } from '@Components/Grid/components/Table/formatters';
import { formatDate } from '@Utils/index';

export default function DescriptionFormatter({ info }) {
  const { value, row } = getInfo(info)
  const { definitions: { basePath, entityNameModule, entityNamePlural } } = useGrid()

  return <>
    <NameAndLabelFormatter
      editLink={buildEditLink({ basePath, entityNameModule, entityNamePlural, row })}
      title={value}
      subtitle={`Created at: ${formatDate(row.created_at, 'MMM DD, YYYY - hh:mm A')} by ${row.user.first_name} ${row.user.last_name}`} />
  </>
}
